import script from "./TiTarifa.vue?vue&type=script&lang=ts&setup=true"
export * from "./TiTarifa.vue?vue&type=script&lang=ts&setup=true"

import "./TiTarifa.vue?vue&type=style&index=0&id=9067cb92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9067cb92"]])

export default __exports__